import { add, differenceInDays, endOfDay, startOfDay, subMonths } from "date-fns";

import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";

import { fromJS } from "immutable";

import ActionTypesEnum from "@shared/enums/action-constant.enum";
import rangesModel from "@shared/variables/dateranger-picker";
import DateUtil from "@shared/utils/date.util";
import { CustomEventService } from "@shared/services/custom-event.service";
import { GlobalSettingsService } from "@shared/services/global-settings.service";

import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";


@UntilDestroy()
@Component({
  selector: 'app-daterangepicker',
  templateUrl: './daterangepicker.component.html'
})
export class DaterangepickerComponent implements OnInit {

  notDisplayedDates = [
    'TODAY',
    'FROM_LAST_WEEK',
    'FROM_LAST_TWO_WEEKS',
    'FROM_LAST_MONTH'
  ];

  date = null;
  @Input() useAlwaysStartEndDate = true;


  excludedTypes = [
    ActionTypesEnum.GIT_ANALYTICS,
    ActionTypesEnum.PULL_REQUEST_DATE_EVENT,
    ActionTypesEnum.DORA_DATE_EVENT,
    ActionTypesEnum.SCORECARD_DATE_EVENT
  ];

  dateFormat: string;
  _type = 'default';
  get type(): string {
    return this._type;
  }

  @Input('type')
  set type(type: string) {
    this._type = type;
  };

  activeButton: any;

  @Input() set startDate(value: Date) {
    this._startDate = value;
    this.rangeDate = [value, this.rangeDate[1]];
    this.setPreviousPeriod();
  }

  get startDate() {
    return this._startDate;
  }

  @Input() set endDate(value: Date) {
    this._endDate = value;
    this.rangeDate = [this.rangeDate[0], value];
    this.setPreviousPeriod();
  }

  get endDate(){
    return this._endDate;
  }

  _selectedDate: Base.DurationsModel;
  get selectedDate(): Base.DurationsModel {
    return this._selectedDate;
  }

  @Input('selectedDate')
  set selectedDate(date: Base.DurationsModel) {
    this._selectedDate = date;
    const ranges: DateRangePicker.Range[] = this.ranges.filter((el) => el.startDate.getTime()?.toString() === date?.fromDate?.toString() && el.endDate.getTime()?.toString() === date?.toDate?.toString());
    if (ranges.length > 0) {
      this.setRange(ranges[0]);
    }

  }

  @Output() startDateChange = new EventEmitter<Date>();
  @Output() endDateChange = new EventEmitter<Date>();
  @Input() selectedRange;
  @Input() selectedType = "daterange";
  @Input() loading: boolean;

  rangeDate = [new Date(), add(new Date(), { days: 3 })];


  isCustom = false;

  isPreviousPeriod = false;
  isLastYearPreviousPeriod = false;

  compareStartDate: Date;
  compareEndDate: Date;

  private _startDate: Date;
  private _endDate: Date;

  ranges: DateRangePicker.Range[];
  hiddenLabel: boolean;
  constructor(private customEventService: CustomEventService,
              private globalSettingsService: GlobalSettingsService) {
    this.ranges = fromJS(rangesModel).toJS();
  }


  ngOnInit(): void {
    this.selectedRange = this.ranges.map(item => item.isActive === false);
    this.dateFormat = this.globalSettingsService.dateFormat;

    this.customEventService.eventAnnounced$.pipe(
      untilDestroyed(this)
    ).subscribe(
      ({ action, data }) => {
        if (action === ActionTypesEnum.SEND_TSC_INFORMATION) {
          this.hiddenLabel = true;
          this.ranges.map(range => (range.key === 'TODAY' ? delete range.label : '') && range.key !== 'FROM_LAST_THREE_MONTHS' )
        }
        if (action === ActionTypesEnum.AGILE_SPACE_DATE_EVENT) {
          this.ranges = this.ranges.filter(range => !this.notDisplayedDates.includes(range.key));
        }
        if (this.excludedTypes.includes(action)) {
          this.ranges = this.ranges.filter(range => range.key !== 'FROM_LAST_THREE_MONTHS');
        }
      });

  }


  onChange(result: Date[]): void {
    if(this.rangeDate[0].getTime() > this.rangeDate[1].getTime()){
      this.rangeDate.reverse();
    }
    this.ranges.forEach(el => el.isActive = false);
    this.startDateChange.emit(this.rangeDate[0]);
    this.endDateChange.emit(this.rangeDate[1]);
    this.isCustom = true;
  }


  setRange(range?: any) {
    this.selectedRange = range;
    this.customEventService.announceEvent(ActionTypesEnum.PICKER_SELECTED_RANGE, this.selectedRange);
    this.ranges.forEach(el => el.isActive = false);
    range.isActive = true;
    this.isCustom = false;
    this.rangeDate = [range.startDate, range.endDate];
    this.startDateChange.emit(this.rangeDate[0]);
    this.endDateChange.emit(this.rangeDate[1]);
    this.setActiveButton(range.key);
  }
  setActiveButton(key: string): void {
    this.activeButton = this.ranges.filter(item => item.key === key)[0].key;
  }

  setPreviousPeriod() {
    this.isPreviousPeriod = true;
    this.isLastYearPreviousPeriod = false;
    const dateDifference = differenceInDays(this.rangeDate[1], this.rangeDate[0]);
    this.compareEndDate = add(this.rangeDate[0], {
      days: -1
    });
    this.compareStartDate = add(this.compareEndDate, {
      days: -1 * dateDifference
    });
  }

  cancelForm() {
    this.customEventService.announceEvent(ActionTypesEnum.CLOSE_DROPDOWN);
  }

  submitForm() {
    let fromDate;
    let toDate;
    fromDate = DateUtil.formatDate(startOfDay(this.startDate));
    toDate = DateUtil.formatDate(endOfDay(this.endDate));
    if (this.isCustom) {
      this.customEventService.announceEvent(ActionTypesEnum.UPDATE_DURATIONS_DATE, {
        period: "CUSTOM_DATE",
        fromDate,
        toDate
      });
      return;
    } else if (this.useAlwaysStartEndDate) {
      this.customEventService.announceEvent(ActionTypesEnum.UPDATE_DURATIONS_DATE, {
        period: this.activeButton,
        fromDate,
        toDate
      });
    } else {
      this.customEventService.announceEvent(ActionTypesEnum.UPDATE_DURATIONS_DATE, this.activeButton);
    }
  }

}
